const TZ = "Asia/Dubai";

/** "YYYY-MM" of the current month in Dubai time */
export function currentMonthKey() {
  return todayDubai().slice(0, 7);
}

/**
 * Ordered list of { value:"YYYY-MM", label:"Mon YYYY" } from Jan 2025 → current month.
 * Most-recent first so the dropdown is naturally ordered.
 */
export function monthOptions() {
  const months = [];
  const [curY, curM] = currentMonthKey().split("-").map(Number);
  let y = curY, m = curM;
  while (y > 2024 || (y === 2025 && m >= 1)) {
    const label = new Date(y, m - 1, 1).toLocaleDateString("en-GB", {
      month: "short", year: "numeric",
    });
    months.push({ value: `${y}-${String(m).padStart(2, "0")}`, label });
    m--;
    if (m === 0) { m = 12; y--; }
  }
  return months;
}

/** YYYY-MM-DD in Dubai time (safe default for date inputs) */
export function todayDubai() {
  return new Date().toLocaleDateString("en-CA", { timeZone: TZ });
}

/** Current year and month in Dubai time */
export function nowDubai() {
  const parts = new Intl.DateTimeFormat("en", {
    timeZone: TZ, year: "numeric", month: "numeric",
  }).formatToParts(new Date());
  return {
    year:  parseInt(parts.find(p => p.type === "year").value),
    month: parseInt(parts.find(p => p.type === "month").value),
  };
}

/** "02 Jun 2026" — display format for date strings */
export function fmtDate(isoStr) {
  try {
    return new Date(isoStr).toLocaleDateString("en-GB", {
      day: "2-digit", month: "short", year: "numeric", timeZone: TZ,
    });
  } catch { return isoStr || "—"; }
}

/** "02 Jun · 14:30" — display format for timestamps */
export function fmtDateTime(isoStr) {
  try {
    return new Date(isoStr).toLocaleString("en-GB", {
      day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", timeZone: TZ,
    });
  } catch { return isoStr || "—"; }
}
